export const overrideH1ToH3 = {h1: 'h3'};
export const overrideH1ToH4 = {h1: 'h4'};
